import { toast } from './toast'
import { captureException } from './sentry'

export interface AppError {
  message: string
  code?: string
  status?: number
  timestamp: Date
}

export class ErrorHandler {
  static handle(error: unknown, context?: string) {
    const appError = this.normalize(error)

    // Send to Sentry (no-ops gracefully if Sentry not initialized)
    captureException(error, context)

    // Show user-friendly message
    this.showUserError(appError)
  }
  
  private static normalize(error: unknown): AppError {
    if (error instanceof Error) {
      return {
        message: error.message,
        timestamp: new Date()
      }
    }
    return {
      message: 'An unexpected error occurred',
      timestamp: new Date()
    }
  }
  
  private static showUserError(error: AppError) {
    const userMessage = error.message || 'Something went wrong. Please try again.'
    toast.raw.error(userMessage)
  }
}
